interface StepProgressProps {
  currentStep: 1 | 2 | 3;
  stepLabel: string;
}

export function StepProgress({ currentStep, stepLabel }: StepProgressProps) {
  return (
    <div className="space-y-3">
      <div className="flex justify-between items-center">
        <span className="text-sm text-muted-foreground">Step {currentStep} of 3</span>
        <span className="text-sm text-muted-foreground">{stepLabel}</span>
      </div>
      <div className="flex gap-3">
        <div className={`h-1 rounded-full flex-1 transition-colors ${currentStep >= 1 ? 'bg-primary' : 'bg-secondary'}`}></div>
        <div className={`h-1 rounded-full flex-1 transition-colors ${currentStep >= 2 ? 'bg-primary' : 'bg-secondary'}`}></div>
        <div className={`h-1 rounded-full flex-1 transition-colors ${currentStep >= 3 ? 'bg-primary' : 'bg-secondary'}`}></div>
      </div>
    </div>
  );
}
